import { render } from "./VendorCreate.vue?vue&type=template&id=5b725620"
import script from "./VendorCreate.vue?vue&type=script&lang=js"
export * from "./VendorCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__